/**
 * Phase 1 手动模拟发言台：真人在 textarea 输入/粘贴自己刚说的话，
 * 提交后交给端侧断言引擎（Mock 后端用内置正则复刻）扫描口径错误。
 *
 * Phase 2 将由流式 ASR 适配器自动写入同一入口，UI 无需改动。
 */
import type { Side } from '@zongheng/core-schema';
import { sideLabel } from '@zongheng/core-schema';
import { Badge, Button, KeyHint } from '../ui/primitives.tsx';

export function TranscriptPanel({
  selfSide,
  draft,
  onChangeDraft,
  onSubmit,
}: {
  selfSide: Side;
  draft: string;
  onChangeDraft: (text: string) => void;
  onSubmit: () => void;
}) {
  const submit = () => onSubmit();
  return (
    <section
      data-testid="hud-transcript"
      aria-label="手动模拟发言"
      className="rounded-xl border border-white/10 bg-bg-surface/80 p-3 backdrop-blur"
    >
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-sm font-semibold tracking-wide text-slate-100">
          发言模拟台 · {sideLabel(selfSide)}
        </h2>
        <div className="flex items-center gap-2">
          <Badge tone="warning">Phase 1 手动 ASR</Badge>
          <KeyHint>Ctrl+Enter 提交</KeyHint>
        </div>
      </div>
      <textarea
        data-testid="hud-transcript-input"
        value={draft}
        rows={3}
        placeholder="把刚才的发言文本粘贴到这里（例如：闭卷考成绩提高了 24%…），提交后端侧断言引擎会立即扫描数据张冠李戴。"
        onChange={(event) => onChangeDraft(event.target.value)}
        onKeyDown={(event) => {
          if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
            event.preventDefault();
            submit();
          }
        }}
        className="w-full resize-y rounded-lg border border-white/15 bg-black/30 px-3 py-2 text-sm leading-relaxed text-slate-100 outline-none placeholder:text-slate-600 focus:border-team-aff/60"
      />
      <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
        <p className="text-[11px] text-slate-500">
          提交后自动清空；命中内置断言语料会点亮右侧「断言告警」。
        </p>
        <Button
          variant="primary"
          size="sm"
          onClick={submit}
          testId="hud-transcript-submit"
          title="提交并扫描（Ctrl+Enter）"
        >
          提交并扫描
        </Button>
      </div>
    </section>
  );
}
